import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Floating "scroll to top" button — appears once the user has scrolled
// past ~600px on any route and animates the page back to the top on click.
const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Scroll to top"
      data-testid="scroll-to-top"
      className={`fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-neutral-900 dark:bg-white text-white dark:text-neutral-900 shadow-[0_10px_30px_-10px_rgba(0,0,0,0.4)] dark:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.7)] flex items-center justify-center transition-all duration-300 hover:scale-105 hover:bg-neutral-700 dark:hover:bg-neutral-200 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <ArrowUp className="w-5 h-5" strokeWidth={2.25} />
    </button>
  );
};

export default ScrollToTop;
